import {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import _ from "lodash";
import {organizationSettingsActions} from "_actions";

export default function useGetDisableProcesses(organizationId) {
    const dispatch = useDispatch();

    useEffect(() => {
        if (!_.isEmpty(organizationId)) {
            dispatch(organizationSettingsActions.fetchOrganizationDisableProcesses(organizationId));
        }
    }, [organizationId]);

    const organizationSettings = useSelector(state => state.organizationSettings);
    const loading = organizationSettings.loadingDisableProcesses;
    const disableProcesses = organizationSettings.disableProcesses;

    return {disableProcesses, loading};
}
